import React from 'react';
import PropTypes from 'prop-types';
import { SelectCascade, SelectTree } from '@tencent/spaui-business';
import { Select } from '@tencent/spaui';
import { connect } from 'react-redux';
import _ from 'lodash';

// 推广目标选择组件

const reportHubDefaultKey = 'promoted-object-select';

export const ADPLATMFORM_MAP = {
  AD_PLATFORM_TYPE_GDT: '广点通',
  AD_PLATFORM_TYPE_MP: '微信',
  AD_PLATFORM_TYPE_NEIGHBORHOOD: '附近推',
  AD_PLATFORM_TYPE_MP_SOSO: '搜一搜',
  AD_PLATFORM_TYPE_SOGOU: '搜狗',
  AD_PLATFORM_TYPE_LOCAL: '本地推',
  AD_PLATFORM_TYPE_MUTUAL_SELECTION: '互选营销',
};

class PromotedObjectSelect extends React.Component {
  static propTypes = {
    promotedObjectRepo: PropTypes.object.isRequired,
  }
  render() {
    // 多层筛选，从接口获取
    // const { promotedObjectRepo, adPlatformType, promotedObject, onlyShowAdPlatformType, hideAdPlatform = [], mode, props = {}, treeData = [] } = this.props
    // const data = _.map(promotedObjectRepo, (promotedObjects, adPlatform) => {
    //   if (hideAdPlatform.indexOf(adPlatform) === -1) {
    //     return {
    //       value: adPlatform,
    //       desc: ADPLATMFORM_MAP[adPlatform] || "未知平台",
    //       options: onlyShowAdPlatformType
    //         ? null
    //         : _.map(promotedObjects, (desc, value) => {
    //             return {
    //               value: adPlatform + ":" + value,
    //               desc,
    //             }
    //           }),
    //     }
    //   }
    // })

    // 一层筛选，前端写死
    const { adPlatformType, adPlatformTypes, promotedObject, mode, props = {}, treeData = [], reportHubKey } = this.props;

    const reportKey = reportHubKey || reportHubDefaultKey;

    const data = Object.keys(ADPLATMFORM_MAP).map((key) => ({
      value: key,
      desc: ADPLATMFORM_MAP[key],
      options: null,
    }));

    const dataSelect = Object.keys(ADPLATMFORM_MAP).map((key) => ({
      value: key,
      label: ADPLATMFORM_MAP[key],
      'data-report': `${reportKey}-${key}`,
    }));
    let selectValue = '';
    if (adPlatformType !== undefined && adPlatformType !== '') {
      selectValue = adPlatformType;
    }

    let value = '';
    if (adPlatformType !== undefined && adPlatformType !== '' && promotedObject !== undefined && promotedObject !== '') {
      value = `${adPlatformType}:${promotedObject}`;
    } else if (adPlatformType !== undefined && adPlatformType !== '') {
      value = adPlatformType;
    }
    if (mode === 'selectTree') {
      return <SelectTree
        clear
        multiple
        data={data}
        value={treeData}
        onChange={this.handleTreeChange}
        data-report={reportKey}
        {...props}
      />;
    }
    return <Select
      multiple
      data-report={reportKey}
      data={dataSelect}
      value={adPlatformTypes || adPlatformType || ''}
      onChange={this.handleChange}
      clear={true}
    />;
  }

  handleChange = (event, value) => {
    this.props.onChange({
      adPlatformType: value,
      adPlatformTypes: value,
      promotedObject: '',
    });
  }

  handleTreeChange = (event, value, treeNode, valueNodeMap) => {
    const adPlatformType = []; const promotedObject = [];
    _.map(value, (v) => {
      const [_adPlatformType, _promotedObject] = v.split(':');
      if (!_.includes(adPlatformType, _adPlatformType)) { adPlatformType.push(_adPlatformType); }
      if (_promotedObject) {
        promotedObject.push(_promotedObject);
      }
    });
    this.props.onChange(value, treeNode, valueNodeMap, { adPlatformType, promotedObject });
  }
}

function mapStateToProps(state, ownProp) {
  return {
    promotedObjectRepo: state.promotedObjectRepo,
  };
}

export default connect(mapStateToProps)(PromotedObjectSelect);
